/*
 * @Author: your name
 * @Date: 2021-11-10 15:18:30
 * @LastEditTime: 2021-11-16 11:08:28
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/utils/iconsTypes.js
 */
const iconList = [
  {
    code: '1',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-22.png',
  },
  {
    code: '2',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-23.png',
  },
  {
    code: '3',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-cet.png',
  },
  {
    code: '4',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-accountant.png',
  },
  {
    code: '5',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-university.png',
  },
  {
    code: '6',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-computer.png',
  },
  {
    code: '7',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-Japanese.png',
  },
  {
    code: '8',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-22.png',
  },
  {
    code: '9',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-22.png',
  },
  {
    code: '10',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-25.png',
  },
  {
    code: '11',
    imgUrl: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/icon-22.png',
  },
  {
    code: '12',
    imgUrl: 'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-26.png',
  },
];

export default iconList;
